import React        from 'react';
import PropTypes    from 'prop-types';
import ReloadHelper from "../../../utils/ReloadHelper";
import { generateKey } from '../../../utils/CommonUtils';

class Background extends React.Component {

	constructor(props) {
		super(props);

		this.video = null;

		this.onClickVideo = this.onClickVideo.bind(this);
		this.startVideo   = this.startVideo.bind(this);
		this.stopVideo    = this.stopVideo.bind(this);
	}

	onClickVideo() {
		if (!this.video.paused) {
			this.video.pause();
		} else {
			this.video.play();
		}
	}

	startVideo() {
		if (this.video) {
			this.video.play();
		}
	}

	stopVideo() {
		if (this.video) {
			this.video.pause();
		}
	}

	onClickActor(e, link) {
		ReloadHelper.reloadWithPjax(link, e);
	}


	render() {
		const actors = [];

		for (let i = 0; i < this.props.actors.length; i++) {
			const actor = this.props.actors[i];

			let actorOnline = '';
			if (actor.isOnline) {
				actorOnline = ' is-online';
			}

			const onClick = (e) => {
				this.onClickActor(e, actor.profileLink);
			};

			const badge = (
				<div key={generateKey("badge-container", actors.length)} className="video-jumbotron__background-actor-badge-container">
					<div className={"video-jumbotron__background-actor-image-container" + actorOnline}>
						<a href={actor.profileLink} className="video-jumbotron__background-actor-link" onClick={onClick}>{actor.name}</a>
						<img className={"video-jumbotron__background-actor-image"} src={actor.previewPictureUrl} />
					</div>
					<div className="video-jumbotron__background-actor-badge-name" onClick={onClick}>{actor.name}</div>
				</div>
			);

			actors.push(badge);
		}

		const content = !this.props.showVideo
			? <picture><img src={this.props.image} /></picture>
			: (
				<div className="video-jumbotron__background-wrapper">
					<div className="video-jumbotron__background-actor-container">{actors}</div>
					<video ref={ref => this.video = ref} autoPlay muted loop id="jumbotron-video-background">
						<source src={this.props.video} type={this.props.videoMimeType} />
					</video>
				</div>
			);

		return (
			<div className="video-jumbotron__background">{!this.props.isMobile ? content : null}</div>
		);
	}
}

Background.propTypes = {
	image:         PropTypes.string,
	video:         PropTypes.string,
	videoMimeType: PropTypes.string,
	showVideo:     PropTypes.bool,
	isMobile:      PropTypes.bool,
	actors:        PropTypes.arrayOf(PropTypes.shape({
		id:                PropTypes.number,
		name:              PropTypes.string,
		profileLink:       PropTypes.string,
		previewPictureUrl: PropTypes.string,
		isOnline:          PropTypes.bool,
	})),
};

Background.defaultProps = {
	showVideo: false,
	isMobile:  false,
	actors:    [],
};

export default Background;
